import { SignUpState } from '../../types';

const state: SignUpState = {
  name: '',
  email: '',
  phone: '',
  organization: '',
  businessType: 'WHOLESALER',
};

export default state;
